function VehicleDefaultValueRequestTransformer(
	Util,
	jsonMapper,
	userInputRepository,
	quoteOptions
) {
	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = '{0} at {1} AEST';
		var timeFormatted = '4:00PM';
		if (time)
			timeFormatted = moment()
				.tz('Australia/Sydney')
				.format('h:mma');
		return Util.stringFormat(
			format,
			moment()
				.tz('Australia/Sydney')
				.format('Do MMM YYYY'),
			timeFormatted
		);
	}

	var staticValuesMapping = {
		quoteType: 'Full',
		productCode: 'QPMMotorVehicle',
		// "anyInfringementsQuestion": "no",
		// "anyClaimsQuestion": "no",
		// "anyLostLicencesQuestion": "no",
		// "anyConvictionsQuestion": "no",
		'vehicles.0.primaryUsage': 'private',
		'vehicles.0.afterMarketModifications': false,
		'vehicles.0.isEligibleforSDExemption': false,
		'vehicles.0.financeType': 'none',
		'vehicles.0.sumInsuredType': 'market',
		'vehicles.0.garageType': 'garage',
		'vehicles.0.unrepairedDamage': 'none',
		'vehicles.0.colour': 'red',
		'vehicles.0.coverType': 'comprehensive',
		'vehicles.0.recentPurchase': false,
		'vehicles.0.otherDriverHasProLicense': false,
		'vehicles.0.youngestDriverGender': 'male',
		'vehicles.0.otherDriverUsageTimes': '0',
		'vehicles.0.sumInsuredAmount': '1000',
		'vehicles.0.garageAddress.addressType': 'postal',
		'vehicles.0.drivers.*.driver.licenceType': 'full',
		'vehicles.0.drivers.*.driver.yearsLicenced': '6',
		'vehicles.0.drivers.*.driver.hasConviction': false,
		'vehicles.0.drivers.*.driver.hasClaim': false,
		'vehicles.0.drivers.*.driver.hasInfringement': false,
		'vehicles.0.drivers.*.driver.hasLostLicence': false,
		'vehicles.0.drivers.*.driver.zeroDemerits': true,
		'vehicles.0.drivers.*.driver.previousInsurer': 'none',
		'vehicles.0.drivers.*.driver.noClaimBonus': 'rating_1',
		'vehicles.0.drivers.*.driver.maxNoClaimBonusLength': '2',
		// "vehicles.0.drivers.*.driver.calculatedExcess": 0,
		'vehicles.0.drivers.*.driver.person.contactType': 'person',
		'vehicles.0.drivers.*.driver.person.gender': 'male',
		'vehicles.0.drivers.*.driver.person.firstName': 'An@n',
		'vehicles.0.drivers.*.driver.person.lastName': 'An@nym@us',
		'vehicles.0.drivers.*.driver.person.isJustInsured': false,
		'vehicles.0.drivers.*.driver.person.dateOfBirth': '01/06/2000',
		email: 'a@a.com',
		'vehicles.0.availableCoverTypes': [
			'comprehensive',
			'comprehensive_nominated',
			'comprehensive_preferred',
			'third_party_fire_theft',
			'third_party'
		],
		availableSumInsuredTypes: ['market', 'agreed'],
		'vehicles.0.coverageOptions': [
			{
				name: 'QPMMotVehHireCar',
				selected: false,
				required: false
			},
			{
				name: 'QPMMotVehWindscreen',
				selected: false,
				required: false
			},
			{
				name: 'QPMMotVehNCB',
				selected: false,
				required: false
			}
		],
		'vehicles.0.excess.standardVehicleExcess': 650,
		'vehicles.0.excess.ageExcessTier1': 1000,
		'vehicles.0.excess.ageExcessTier2': 750,
		'vehicles.0.excess.undeclaredDriverTier2': 500,
		'vehicles.0.excess.inexperiencedDriver': 750,

		'policyHolders.0.mainHolder': true,
		'policyHolders.0.contact.isJustInsured': false,
		'policyHolders.0.contact.contactType': 'person',
		'policyHolders.0.contact.dateOfBirth': '01/06/2000',
		// full quote transformation :
		status: 'Draft',
		documentDeliveryMethod: 'email',
		displayStatus: 'Draft',
		periodStartDateTimeAEDT: formatDateAndTimeTheGuidewireWay(
			moment(),
			moment()
		),
		periodEndDateTimeAEDT: formatDateAndTimeTheGuidewireWay(
			moment().add(1, 'years')
		),
		channel: 'portal',
		'vehicles.0.drivers.*.driverUsage': 'other'
	};

	function transform(intermediateRequest, userInput) {
		var staticValuesMappingNew = ApplyDefaultExcess(userInput);
		var transformedRequest = jsonMapper.setDefault(
			userInput,
			staticValuesMappingNew
		);
		return transformedRequest;
	}

	function ApplyDefaultExcess(userInput) {
		var staticValuesMappingNew = staticValuesMapping;
		var excessValue = quoteOptions.getStateDefaultVoluntaryExcess(
			userInput.policyAddress.state
		);
		if (excessValue != null) {
			var tempObj = {
				'vehicles.0.excess.voluntaryVehicleExcess': excessValue
			};
			staticValuesMappingNew = Object.extend(
				staticValuesMapping,
				tempObj
			);
		}
		return staticValuesMappingNew;
	}

	return {
		transform: transform
	};
}
